<template>
  <div
    v-show="dragdrop_controller.is_active && props.event_name === dragdrop_controller.drags.event"
    class="drag-drop drag-drop-visible">
    <i :class="icon[type]"></i>
    <span>
      {{ Language.say(message[type], [dragdrop_controller.drags.data.count]) }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Language     from "@/js/Shared/Language/Language";

const props = defineProps({
  dragdrop_controller: {},
  event_name:     '',
  icon:           {},
  message:        {},
});

const type = computed(() => {
  return (props.dragdrop_controller.drags.data.count === 1) ? 'single' : 'multiple';
});
</script>
